import React from 'react';

interface PinterestIconProps {
  className?: string;
}

const PinterestIcon: React.FC<PinterestIconProps> = ({ className }) => (
  <i
    className={['fa-brands fa-pinterest', className].filter(Boolean).join(' ')}
    aria-hidden="true"
  />
);

export default PinterestIcon;
